import { CegidIntegrationStatus } from '@features/cegidIntegration/enums/cegidIntegrationStatus'

import { CpaToolsIntegrationStatus } from '../../../enums/cpaToolsIntegrationStatus'

export const cpaToolsToCegidIntegrationStatus: Record<CpaToolsIntegrationStatus, CegidIntegrationStatus> = {
  [CpaToolsIntegrationStatus.CreateRejected]: CegidIntegrationStatus.Failed,
  [CpaToolsIntegrationStatus.CreateStarted]: CegidIntegrationStatus.Pending,
  [CpaToolsIntegrationStatus.CreateSuccess]: CegidIntegrationStatus.Posted,
}
